const routes = [
  {
    path: "/tiposproducto",
    component: () =>
      import(/* webpackChunkName: "tiposproducto" */ "./Tiposproducto"),
  },
];
export default routes;
